import { ResizeObserver } from '@juggle/resize-observer';

function initTitleResize() {
  const assertElementFitsWidth = () =>
    titleChildEl.offsetWidth <= titleParentEl.offsetWidth;
  const assertElementFitsHeight = () =>
    titleChildEl.offsetHeight <= titleParentEl.offsetHeight;

  const prepFontOptions = (fontSize) => {
    const defOpts = { fontSize, paddingRight: 3 };

    if (fontSize > 71) {
      return {
        ...defOpts,
        lineHeight: fontSize * 0.25 + fontSize,
      };
    } else if (fontSize > 65) {
      return {
        ...defOpts,
        lineHeight: fontSize * 0.27 + fontSize,
      };
    } else if (fontSize > 46) {
      return {
        ...defOpts,
        lineHeight: fontSize * 0.28 + fontSize,
      };
    } else if (fontSize > 37) {
      return {
        ...defOpts,
        lineHeight: fontSize * 0.32 + fontSize,
      };
    } else if (fontSize > 32) {
      return {
        ...defOpts,
        lineHeight: fontSize * 0.37 + fontSize,
      };
    } else if (fontSize > 27) {
      return {
        ...defOpts,
        lineHeight: fontSize * 0.36 + fontSize,
      };
    } else if (fontSize > 23) {
      return {
        ...defOpts,
        lineHeight: 33.2,
        paddingRight: 2,
      };
    } else if (fontSize > 19) {
      return {
        ...defOpts,
        lineHeight: 29.2,
        paddingRight: 2,
      };
    } else if (fontSize > 17) {
      return {
        ...defOpts,
        lineHeight: 24,
        paddingRight: 1,
      };
    } else if (fontSize > 15) {
      return {
        ...defOpts,
        lineHeight: 22.4,
        paddingRight: 1,
      };
    } else if (fontSize > 13) {
      return {
        ...defOpts,
        lineHeight: 20.4,
        paddingRight: 1,
      };
    } else {
      return {
        ...defOpts,
        lineHeight: 18.4,
        paddingRight: 1,
      };
    }
  };
  const prepStyles = ({ fontSize, lineHeight, ready, paddingRight }) => `
    #TitleMainWrapper {
      display: none;
      height: 100%;
      position: fixed;
      top: ${top}vh;
      left: ${left}vw;
      height: ${height}vh;
      width: ${width}vw;
      overflow-y: hidden;
    }

    @media (min-width: 600px) {
      #TitleMainWrapper {
        left: auto;
        width: calc(470px * ${width / 100});
        transform: translateX(calc(470px * ${left / 100}));
      }
    }

    @media (min-width: 961px) {
      #TitleMainWrapper {
        width: calc(470px * (${width / 100} + 0.08));
        transform: translateX(calc(470px * (${left / 100} - 0.04)));
      }
    }

    #TitleMainWrapper #TitleParent {
      font-size: ${fontSize}px;
      line-height: ${lineHeight}px;
      overflow: ${ready ? 'inherit' : 'hidden'};
      height: 100%;
      opacity: ${ready ? 1 : 0.01} !important;
    }

    #TitleMainWrapper #TitleParent span {
      padding-right: ${paddingRight}px;
    }

    #TitleMainWrapper #TitleParent #TitleChild {
      display: ${ready ? 'block' : 'inline-block'};
    }
    `;
  const setStyles = (fontSize, { ready }) => {
    const options = prepFontOptions(fontSize);
    const styles = prepStyles({ ...options, ready });
    const titleMainEl = document.getElementById('TitleMainWrapper');

    if (titleMainEl) {
      // this logic prevents font size 'jumping' on the page
      titleMainEl.style.display = 'block';
    }
    stylesEl.innerHTML = styles;
  };

  const resizeFont = (currentPid, fontSize) => {
    if (pid !== currentPid) {
      return;
    }

    if (fontSize === fontMin) {
      return setStyles(fontSize, {
        ready: true,
      });
    }

    setStyles(fontSize, { ready: false });

    const isFit = assertElementFitsHeight() && assertElementFitsWidth();

    if (isFit) {
      setStyles(fontSize, {
        ready: true,
      });
      contentWrapper.style.overflow = 'hidden';
      return;
    }

    resizeFont(currentPid, fontSize - 1);
  };

  const prepConfig = (el) => {
    const config = Object.assign({}, el.dataset);
    const { width, height, top, left, fontMin, fontMax } = config;

    return {
      width: parseInt(width),
      height: parseInt(height),
      top: parseInt(top),
      left: parseInt(left),
      fontMin: parseInt(fontMin),
      fontMax: parseInt(fontMax),
    };
  };

  let pid = 0;
  const contentWrapper = document.querySelector('.ha-form__content-wrapper');
  const titleMainEl = document.getElementById('TitleMainWrapper');
  const titleParentEl = document.getElementById('TitleParent');
  const titleChildEl = document.getElementById('TitleChild');

  if (!titleMainEl || !titleParentEl || !titleChildEl) {
    setTimeout(initTitleResize, 10);
    return;
  }

  const stylesEl = document.createElement('style');
  document.head.appendChild(stylesEl);

  const config = prepConfig(titleMainEl);
  const { width, height, top, left } = config;
  let { fontMax, fontMin } = config;
  const paragraphEl = document.querySelector('#TitleChild p');

  if (document.querySelector('#TitleChild h1')) {
    // Size of h1 is 2em, because of that max font size
    // should be such one to make h1 to be with max font size
    fontMax = parseInt(fontMax / 2);

    if (!paragraphEl) {
      // Size of h1 is 2em, because of that min font size
      // should be such one to make h1 to be with min font size
      fontMin = parseInt(fontMin / 2);
    }
  } else if (document.querySelector('#TitleChild h2')) {
    fontMax = parseInt(fontMax / 1.5);

    if (!paragraphEl) {
      fontMin = parseInt(fontMin / 1.5);
    }
  } else if (document.querySelector('#TitleChild h3')) {
    fontMax = parseInt(fontMax / 1.17);

    if (!paragraphEl) {
      fontMin = parseInt(fontMin / 1.17);
    }
  } else if (!paragraphEl) {
    fontMin = parseInt(fontMin / 1.5);
  }

  const observer = new ResizeObserver(() => {
    pid = pid + 1;
    resizeFont(pid, fontMax);
  });

  observer.observe(titleParentEl);
  observer.observe(document.body);
};

document.addEventListener('turbo:load', initTitleResize);
document.addEventListener('turbo:render', initTitleResize);
